import {Model, ModelMixin} from '../../common/model.class';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class Language extends ModelMixin() implements Model<Language> {

    TYPE = Language;

    public code: string;
    public name: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/language/language.model.ts